import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    deepStringFind,
    inject,
    ModalHandle,
    NothingHere,
    SubTopBar,
    Title,
    toArray,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsServer } from '@react-icons/all-files/bs/BsServer';
import { RouteComponentProps } from 'react-router';
import { Input } from 'reactstrap';
import { AppStore } from '../Core/AppStore';
import { CreateNocServerModal } from './CreateNocServerModal';
import { NocServerItem } from './NocServerItem';
import { NocServersStore } from './NocServersStore';

export interface INocServersListProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class NocServersList extends React.Component<INocServersListProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.nocServersStore.loadAllAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container">
                <Title>Noc Servers</Title>

                <SubTopBar>
                    <Input
                        type="text"
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                        placeholder="Search for Noc Server..."
                    />

                    <div className="mx-2 border" />

                    <a className="btn btn-primary" onClick={this.openCreateServerModal}>
                        Create Server
                    </a>
                </SubTopBar>

                <div className="row">
                    <div className="col-12">
                        <div className="list-group">
                            {this.nocServers.map(s => (
                                <NocServerItem key={s.serverName} nocServer={s} />
                            ))}
                        </div>
                    </div>
                </div>

                <NothingHere
                    empty={!this.nocServers.length}
                    icon={<BsServer />}
                    loading={this.loading}
                    label="No Noc Servers Returned"
                    loadingMessage="Loading Servers..."
                />
                <CreateNocServerModal modalHandle={this.createServerModal} history={this.props.history} />
            </div>
        );
    }

    @bind
    private openCreateServerModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.createServerModal.open();
    }

    @bind
    @action
    private async onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @computed
    private get nocServers() {
        let nocServers = toArray(this.nocServersStore.nocServers);

        if (this.searchValue) nocServers = nocServers.filter(o => deepStringFind(o, this.searchValue));

        return nocServers;
    }

    @observable
    private searchValue: string = '';
    private createServerModal = new ModalHandle();
    @observable
    private loading = false;
    @inject
    private appStore!: AppStore;
    @inject
    private nocServersStore!: NocServersStore;
}
